<template>
    <BreadCrumb PageTitle="Ajouter un marchand" />
    <AddMarchand />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../../components/Common/BreadCrumb.vue";
    import AddMarchand from "../../../components/Ecommerce/Marchand/AddMarchand.vue";
  
    export default defineComponent({
      name: "AddMarchandPage",
      components: {
        BreadCrumb,
        AddMarchand,
      },
    });
  </script>